<div class="void-dialog">

  <!-- Title -->
  <div mat-dialog-title class="dialog-title">
    <span>Void envelope</span>
    <button mat-icon-button aria-label="Close dialog" (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Content -->
  <mat-dialog-content>

    <!-- Warning banner -->
    <div class="warn-banner" role="alert">
      <mat-icon class="warn-icon">error_outline</mat-icon>
      <span>You're voiding an in-progress envelope.</span>
    </div>

    <!-- Explanation -->
    <p class="body-copy">
      By voiding this envelope, you are canceling all remaining signing activities.
      Recipients who have finished signing will receive an email notification that
      includes your reason for voiding. Recipients who have not yet signed will not
      be able to view or sign the enclosed documents.
    </p>

    <!-- Form -->
    <form [formGroup]="voidForm" novalidate>

      <!-- Void Reason label -->
      <p class="field-label">
        Void Reason <span class="required" aria-hidden="true">*</span>
      </p>

      <!-- Radio group -->
      <mat-radio-group
        formControlName="reason"
        aria-label="Void reason"
        class="radio-group">
        <mat-radio-button
          *ngFor="let r of reasons"
          [value]="r.value"
          class="radio-btn">
          {{ r.label }}
        </mat-radio-button>
      </mat-radio-group>

      <!-- Other reason textarea – shown only when 'other' is selected -->
      <mat-form-field        
        appearance="outline"
        class="other-field">
        <textarea
          matInput
          formControlName="otherText"
          cdkTextareaAutosize
          [maxlength]="MAX_LENGTH"
          aria-label="Other void reason">
        </textarea>
        <mat-hint align="end">{{ otherLength }}/{{ MAX_LENGTH }}</mat-hint>
        <mat-error *ngIf="voidForm.get('otherText')?.hasError('required')">
          Please enter a reason.
        </mat-error>
      </mat-form-field>

    </form>

  </mat-dialog-content>

  <mat-divider></mat-divider>

  <!-- Actions -->
  <mat-dialog-actions align="end" style="margin-right: 10px; margin-bottom: 5px;">
    <button
      mat-raised-button
      color="primary"
      [disabled]="!canSubmit"
      (click)="onVoid()">
      Void
    </button>
  </mat-dialog-actions>

</div>
